import { useEffect, useMemo } from 'react';

const COLORS = ['#ea580c', '#fb923c', '#fbbf24', '#22c55e', '#f97316'];

/** Lightweight 1–2s confetti burst - no external dependency. */
export function ConfettiBurst({ active }: { active: boolean }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: 28 }, (_, i) => ({
        id: i,
        left: `${4 + ((i * 17) % 92)}%`,
        delay: `${(i % 7) * 0.04}s`,
        duration: `${1 + (i % 5) * 0.12}s`,
        color: COLORS[i % COLORS.length]!,
        size: 4 + (i % 3) * 2,
        drift: i % 2 === 0 ? '-18px' : '18px',
      })),
    [],
  );

  useEffect(() => {
    if (!active) return;
    const timer = setTimeout(() => undefined, 1800);
    return () => clearTimeout(timer);
  }, [active]);

  if (!active) return null;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {pieces.map((piece) => (
        <span
          key={piece.id}
          className="celebration-confetti-piece absolute top-0 rounded-sm opacity-90"
          style={{
            left: piece.left,
            width: piece.size,
            height: piece.size * 1.4,
            backgroundColor: piece.color,
            animationDelay: piece.delay,
            animationDuration: piece.duration,
            ['--confetti-drift' as string]: piece.drift,
          }}
        />
      ))}
    </div>
  );
}
